import $ from "jquery";

$(document).ready(function() {
	$('.jsAccordionTrigger').on('click', function () {
		$(this).closest('.accordion-item').toggleClass('is-active');
		$(this).next('.accordion-item__body').slideToggle(350)
	});
})